/**
 * Factory para criação de Canvas agnóstica ao ambiente (Window ou Worker)
 */
export class CanvasFactory {
    /**
     * Cria um elemento canvas (ou OffscreenCanvas)
     * @param {number} width Largura do canvas
     * @param {number} height Altura do canvas
     * @returns {HTMLCanvasElement|OffscreenCanvas}
     */
    static createCanvas(width = 0, height = 0) {
        // Prefer HTMLCanvasElement in Window environment for better compatibility (toDataURL support)
        if (typeof document !== 'undefined' && document.createElement) {
            const canvas = document.createElement('canvas');
            if (width) canvas.width = width;
            if (height) canvas.height = height;
            return canvas;
        }

        // Fallback to OffscreenCanvas for Workers
        if (typeof OffscreenCanvas !== 'undefined') {
            return new OffscreenCanvas(width, height);
        }

        throw new Error('Ambiente não suporta criação de Canvas');
    }

    /**
     * Verifica se o ambiente suporta OffscreenCanvas
     */
    static supportsOffscreenCanvas() {
        return typeof OffscreenCanvas !== 'undefined';
    }
}
